module.exports = __webpack_public_path__ + "img/ybmbj.8171d391.png";